/**
 * Derived from flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */
import { addPoints } from "./add";
import { interpolatePoints } from "./math";
import { normalizeRing } from "./normalize";
import { rotate } from "./rotate";

export type InterpolateOptions = {
  maxSegmentLength?: number;
  string?: boolean;
};

export function interpolate(
  fromShape: string,
  toShape: string,
  { maxSegmentLength = 10, string = true }: InterpolateOptions = {},
) {
  const fromRing = normalizeRing(fromShape, maxSegmentLength);
  const toRing = normalizeRing(toShape, maxSegmentLength);
  const interpolator = interpolateRing(fromRing, toRing, string);

  if (!string) {
    return interpolator;
  }

  return (t: number) => {
    if (t < 1e-4) {
      return fromShape;
    }

    if (1 - t < 1e-4) {
      return toShape;
    }

    return interpolator(t);
  };
}

export function interpolateRing(
  fromRing: ReturnType<typeof normalizeRing>,
  toRing: ReturnType<typeof normalizeRing>,
  string: boolean,
) {
  const diff = fromRing.length - toRing.length;

  addPoints(fromRing, diff < 0 ? diff * -1 : 0);
  addPoints(toRing, diff > 0 ? diff : 0);

  rotate(fromRing, toRing);

  return interpolatePoints(fromRing, toRing, string);
}
